
import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Project } from "@/types/Project";

interface ProjectFilterProps {
  selectedProjectId: string | "all";
  projects: Project[];
  onProjectChange: (projectId: string | "all") => void;
  placeholder?: string;
  disabled?: boolean;
}

export function ProjectFilter({ 
  selectedProjectId, 
  projects, 
  onProjectChange, 
  placeholder = "Select Project",
  disabled = false 
}: ProjectFilterProps) {
  return (
    <Select 
      value={selectedProjectId} 
      onValueChange={onProjectChange}
      disabled={disabled}
    >
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Projects</SelectItem>
        {projects.map((project) => (
          <SelectItem key={project.id} value={project.id}>
            {project.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
